/* Eventually these strings should get moved to the components they're used in but creating generic file for now to kickoff translations */

import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	databaseTemplateType: {
		id: 'experiment-personalized-templates-v2.database.template',
		defaultMessage: 'Database template',
		description:
			'Subheading text displayed below a template suggestion card to indicate this template is for creating a database content type.',
	},
	getStartedHeader: {
		id: 'experiment-personalized-templates-v2.getting.started.header',
		defaultMessage: 'Get started',
		description:
			'Heading text displayed at the top of the onboarding takeover cards section to introduce the series of action cards that help users get started with Confluence.',
	},
	simpleRetrospectiveTemplate: {
		id: 'experiment-personalized-templates-v2.simple.retrospective.template',
		defaultMessage: 'Simple retrospective',
		description:
			'Title of a whiteboard template for conducting a simple retrospective meeting to reflect on past work.',
	},
	flowchartTemplate: {
		id: 'experiment-personalized-templates-v2.flowchart.template',
		defaultMessage: 'Flowchart',
		description:
			'Title of a whiteboard template for creating flowcharts to visualize processes and workflows.',
	},
	prioritizationMatrixTemplate: {
		id: 'experiment-personalized-templates-v2.prioritization.matrix.template',
		defaultMessage: 'Prioritization matrix',
		description:
			'Title of a whiteboard template for creating a prioritization matrix to rank items by importance and effort.',
	},
	brainwritingTemplate: {
		id: 'experiment-personalized-templates-v2.brainwriting.template',
		defaultMessage: 'Brainwriting',
		description:
			'Title of a whiteboard template for brainwriting sessions where team members write ideas silently.',
	},
	incidentPostmortemTemplate: {
		id: 'experiment-personalized-templates-v2.incident.postmortem.template',
		defaultMessage: 'Incident postmortem',
		description:
			'Title of a whiteboard template for conducting incident postmortem reviews to analyze what went wrong and lessons learned.',
	},
	fourLsTemplate: {
		id: 'experiment-personalized-templates-v2.four.ls.template',
		defaultMessage: '4 Ls Retro',
		description:
			'Title of a whiteboard template for a 4 Ls retrospective (Liked, Learned, Lacked, Longed for).',
	},
	networkOfTeamsTemplate: {
		id: 'experiment-personalized-templates-v2.network.of.teams.template',
		defaultMessage: 'Network of teams',
		description:
			'Title of a whiteboard template for visualizing and organizing a network of teams.',
	},
	disruptiveBrainstormTemplate: {
		id: 'experiment-personalized-templates-v2.disruptive.brainstorm.template',
		defaultMessage: 'Disruptive brainstorm',
		description:
			'Title of a whiteboard template for brainstorming sessions focused on disruptive ideas and innovation.',
	},
	conceptMapTemplate: {
		id: 'experiment-personalized-templates-v2.concept.map.template',
		defaultMessage: 'Concept map',
		description:
			'Title of a whiteboard template for creating concept maps to visually represent relationships between ideas.',
	},
	swimlanesProcessMapTemplate: {
		id: 'experiment-personalized-templates-v2.swimlanes.process.map.template',
		defaultMessage: 'Swimlanes process map',
		description:
			'Title of a whiteboard template for creating swimlane diagrams to map processes across departments or teams.',
	},
	swotAnalysisTemplate: {
		id: 'experiment-personalized-templates-v2.swot.analysis.template',
		defaultMessage: 'SWOT Analysis',
		description:
			'Title of a whiteboard template for conducting SWOT analysis (Strengths, Weaknesses, Opportunities, Threats).',
	},
	focusAreaDiagramTemplate: {
		id: 'experiment-personalized-templates-v2.focus.area.diagram.template',
		defaultMessage: 'Focus area diagram',
		description:
			'Title of a whiteboard template for creating focus area diagrams to identify and visualize key areas.',
	},
	userStoryMapTemplate: {
		id: 'experiment-personalized-templates-v2.user.story.map.template',
		defaultMessage: 'User story map',
		description:
			'Title of a whiteboard template for creating user story maps to organize user journeys and workflows.',
	},
	fishboneDiagramTemplate: {
		id: 'experiment-personalized-templates-v2.fishbone.diagram.template',
		defaultMessage: 'Fishbone diagram',
		description:
			'Title of a whiteboard template for creating fishbone diagrams to identify root causes of problems.',
	},
	orgChartTemplate: {
		id: 'experiment-personalized-templates-v2.org.chart.template',
		defaultMessage: 'Org chart',
		description:
			'Title of a whiteboard template for creating organizational charts to visualize team structure.',
	},
	icebreakersTemplate: {
		id: 'experiment-personalized-templates-v2.icebreakers.template',
		defaultMessage: 'Icebreakers',
		description:
			'Title of a whiteboard template for icebreaker activities to energize teams and build connections.',
	},
	serviceBlueprintTemplate: {
		id: 'experiment-personalized-templates-v2.service.blueprint.template',
		defaultMessage: 'Service blueprint',
		description:
			'Title of a whiteboard template for creating service blueprints to visualize service design.',
	},
	productVisionTemplate: {
		id: 'experiment-personalized-templates-v2.product.vision.board.template',
		defaultMessage: 'Product vision board',
		description:
			'Title of a whiteboard template for creating product vision boards to align team on product goals.',
	},
	workflowTemplate: {
		id: 'experiment-personalized-templates-v2.workflow.template',
		defaultMessage: 'Workflow',
		description: 'Title of a whiteboard template for designing and visualizing workflows.',
	},
	timelineWorkflowTemplate: {
		id: 'experiment-personalized-templates-v2.timeline.workflow.template',
		defaultMessage: 'Timeline workflow',
		description:
			'Title of a whiteboard template for creating timeline workflows to visualize processes over time.',
	},
	teamHealthMonitorTemplate: {
		id: 'experiment-personalized-templates-v2.team.health.monitor.template',
		defaultMessage: 'Team health monitor',
		description: 'Title of a whiteboard template for monitoring team health and tracking metrics.',
	},
	teamCharterTemplate: {
		id: 'experiment-personalized-templates-v2.team.charter.template',
		defaultMessage: 'Team charter template',
		description:
			'Title of a whiteboard template for creating team charters to define team purpose and values.',
	},
	actionPlanTemplate: {
		id: 'experiment-personalized-templates-v2.action.plan.template',
		defaultMessage: 'Action plan',
		description:
			'Title of a whiteboard template for creating action plans to organize tasks and responsibilities.',
	},
	gapAnalysisTemplate: {
		id: 'experiment-personalized-templates-v2.gap.analysis.template',
		defaultMessage: 'Gap analysis',
		description:
			'Title of a whiteboard template for conducting gap analysis to identify differences between current and desired states.',
	},
	productRoadmapTemplate: {
		id: 'experiment-personalized-templates-v2.product.roadmap.template',
		defaultMessage: 'Product roadmap',
		description:
			'Title of a whiteboard template for creating product roadmaps to plan product development.',
	},
	crazy8sBrainstormingTemplate: {
		id: 'experiment-personalized-templates-v2.product.crazy-8s-brainstorming.template',
		defaultMessage: 'Crazy 8s brainstorming',
		description:
			'Title of a whiteboard template for Crazy 8s brainstorming technique to generate multiple ideas rapidly.',
	},
	annualCalendarTemplate: {
		id: 'experiment-personalized-templates-v2.product.annual-calendar.template',
		defaultMessage: 'Annual Calendar',
		description:
			'Title of a whiteboard template for planning annual calendars and organizing events.',
	},
	stakeholderMappingTemplate: {
		id: 'experiment-personalized-templates-v2.product.stakeholder-mapping.template',
		defaultMessage: 'Stakeholder mapping',
		description:
			'Title of a whiteboard template for mapping stakeholders to understand relationships and influence.',
	},
	rootCauseTemplate: {
		id: 'experiment-personalized-templates-v2.product.root-cause.template',
		defaultMessage: 'Root cause analysis',
		description:
			'Title of a whiteboard template for conducting root cause analysis to identify underlying causes of problems.',
	},
	executiveSummaryTemplate: {
		id: 'experiment-personalized-templates-v2.product.executive-summary.template',
		defaultMessage: 'Executive summary',
		description:
			'Title of a whiteboard template for creating executive summaries of key information.',
	},
	elevatorPitchTemplate: {
		id: 'experiment-personalized-templates-v2.product.elevator-pitch.template',
		defaultMessage: 'Elevator pitch',
		description:
			'Title of a whiteboard template for developing elevator pitches and brief communication points.',
	},
});
